<div class="modal-header">
    Clock Out
</div>
<div class="modal-body" id="modal_size">
    <div class="alert alert-warning" [hidden]="customMsg == null">
        <quill-view [content]="customMsg"></quill-view>
    </div>
    <div class="card border" [style.width.px]="panelWidth" [hidden]="!requireSign">
        <div class="card-body" [style.width.px]="panelWidth" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
            <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
            <div class="m-signature-pad">
                <div class="m-signature-pad--body" [ngClass]="{ 'invalid': redBorder == true}" [hidden]="submitSignImg != null">
                    <signature-pad [options]="signaturePadOptions" #signaturePad></signature-pad>
                </div>
                <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                    <img [src]="submitSignImg" [style.max-width.px]="panelWidth - 50" />
                </div>
                <div class="m-signature-pad--footer">
                    <div style="text-align: center;font-size: 12px;">Sign above</div>
                    <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                    <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="!hideClick">Generate Signature</button>
                    <div class="alert alert-warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default border"
            (click)="cancelClicked()">
        Cancel
    </button>
    <button type="button" class="btn btn-success"
            (click)="clockOutClicked()">
        Clock Out
    </button>
</div>
